import type { ID, ThunkReturnType } from "types";
import { useAppDispatch, useRequest, useExportTable } from "hooks";
import { ApiRouteTypes } from "consts/enpoints/api";
import { Filters } from "consts/users";
import { RoleName } from "consts/auth";
import { RequestQueryMapper } from "util/request-query-mapper";
import type { User, UsersResponse } from "features/users/types";
import {
    updateOrAddEntityById,
    changeExportMerchantUsersLoading as changeExportLoading,
    resetMerchantUsers as resetMerchantUsersAction,
    updateOrAddMerchantByIdUsers as updateOrAddMerchantByIdUsersAction,
    deleteMerchantUser as deleteMerchantUserAction
} from "./slice";
import { getMerchantByIdUsersThunk, getMerchantUsersThunk } from "./thunks";

const useMerchantUserActions = () => {
    const dispatch = useAppDispatch();

    const getMerchantUsers = useRequest<ThunkReturnType<UsersResponse>, string | undefined>({
        thunk: getMerchantUsersThunk
    });

    const getMerchantByIdUsers = useRequest<ThunkReturnType<UsersResponse>, string | undefined>({
        thunk: getMerchantByIdUsersThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetMerchantUsers
    });

    const downloadMerchantUsersCsv = (searchQuery: string) => downloadCsv(
        RequestQueryMapper.from(searchQuery)
            .contains(Filters.roleName, RoleName.Merchant)
            .toString()
    );

    const updateOrAddMerchantUserById = (payload: User) =>
        dispatch(updateOrAddEntityById(payload));

    const resetMerchantUsers = () =>
        dispatch(resetMerchantUsersAction());

    const updateOrAddMerchantByIdUsers = (payload: User) =>
        dispatch(updateOrAddMerchantByIdUsersAction(payload));

    const deleteMerchantUser = (payload: ID) => dispatch(deleteMerchantUserAction(payload));

    return {
        downloadCsv: downloadMerchantUsersCsv,
        updateOrAddMerchantUserById,
        updateOrAddMerchantByIdUsers,
        getMerchantUsers,
        getMerchantByIdUsers,
        resetMerchantUsers,
        deleteMerchantUser
    };
};

export default useMerchantUserActions;
